import React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { MasterLayout } from 'layout';
import { header } from 'constants/table';
import DataTable from 'components/data-table';
import { Link, browserHistory } from 'react-router';
import { ContainerFileDinhKem } from 'components/upload';
import { Text, TextMessage } from 'components/tt-forms/common';
import { RowItemDanhSachCuocThanhTra } from 'modules/thanh-tra/datatable';
import { ThanhTra, Danhmuc } from 'api';
import { Toastr } from 'modules/toastr';
import { msg } from "constants/message";
import { HistoryDialog } from 'modules/dialog';
import { ShowIf } from 'components/utils';
import { get } from 'lodash';

class ChiTietDoiTuongTrung extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: [],
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      allowDelete: true,
      detail: {
        cuocThanhTras: [],
        cuocThanhTraCus: [],
        listTaiLieuVanThu: [],
        donViInfo: {},
        enableEdit: true,
        activeTaoCuocThanhTra: true
      },
      thanhTraThanhPhoId: '',
      activeTaoCuocThanhTra: false,
      sendToThanhTra: false,
      posting: false
    }
  }

  componentDidMount() {
    if (this.props.params && this.props.params.id) {
      this.getDetailKHTT(this.props.params.id);
    }
    this.checkDonVi();
  }

  checkDonVi() {
    Danhmuc.actions.getThamSo.request(null, { tuKhoa: 'CQQL_THANH_TRA_THANH_PHO' }).then(res => {
      if (res.data && res.data._embedded) {
        this.setState({ thanhTraThanhPhoId: res.data._embedded.thamSoes.length ? res.data._embedded.thamSoes[0].giaTri : '' });
      }
    });
  }

  getDetailKHTT(idKH) {
    ThanhTra.actions.getKeHoachThanhTraDetail.request({ id: idKH }).then(res => {
      if (res.data) {
        this.state.detail = res.data;
        this.state.activeTaoCuocThanhTra = res.data.activeTaoCuocThanhTra;
        this.state.sendToThanhTra = res.data.saveTamKeHoachTT;
        this.state.enableEdit = (res.data.cuocThanhTras.length == 0);
        res.data.cuocThanhTras.map(item2 => {
          if (item2.tienDoThanhTraInfo == null) {
            this.state.enableEdit = true;
          }
        });
        this.setState({ ...this.state });
      }
    });
  }
  taoCuocThanhTra() {
    this.state.activeTaoCuocThanhTra = true;
    this.handleSave();
  }
  guiThanhTraTP() {
    this.state.sendToThanhTra = true;
    this.handleSave();
  }
  handleSave() {
    let params = {
      keHoachThanhTra: {
        activeTaoCuocThanhTra: this.state.activeTaoCuocThanhTra,
        ghiChu: this.state.detail.ghiChu || '',
        namThanhTra: this.state.detail.namThanhTra || ((new Date()).getFullYear() + 1),
        nguoiKy: this.state.detail.nguoiKy || '',
        quyetDinhPheDuyetKTTT: this.state.detail.quyetDinhPheDuyetKTTT || ''
      },
      sendToThanhTra: this.state.sendToThanhTra
    };
    if (this.state.detail.cuocThanhTras.length) {
      params.cuocThanhTras = [];
    }
    if (this.state.detail.chucNangKeHoachThanhTra) {
      params.keHoachThanhTra.chucNangKeHoachThanhTra = this.state.detail.chucNangKeHoachThanhTra;
    }
    if (this.state.detail.ngayRaQuyetDinh) {
      params.keHoachThanhTra.ngayRaQuyetDinh = moment(this.state.detail.ngayRaQuyetDinh).add(7, 'hours').toISOString();
    }
    this.state.detail.cuocThanhTras.map(item => {
      let pushID = [];
      if (item.doiTuongThanhTraInfo == null) {
        item.listDoiTuongThanhTra.forEach(items => {
          pushID.push(items.doiTuongThanhTraId)
        })
      }

      let itemParams = {
        doiTuongThanhTraId: item.doiTuongThanhTraInfo != null ? item.doiTuongThanhTraInfo.doiTuongThanhTraId : pushID,
        donViChuTriId: item.donViChuTriInfo.coQuanQuanLyId,
        donViPhoiHop: item.donViPhoiHop ? item.donViPhoiHop : '',
        kyThanhTra: item.kyThanhTra ? item.kyThanhTra : '',
        linhVucThanhTra: item.linhVucThanhTraInfo ? item.linhVucThanhTraInfo.type : '',
        noiDungThanhTra: item.noiDungThanhTra ? item.noiDungThanhTra : '',
        thoiHanThanhTra: item.thoiHanThanhTra ? Number(item.thoiHanThanhTra) : 0
      };
      if (item.id) {
        itemParams.id = item.id;
      }
      params.cuocThanhTras.push(itemParams);
    });

    this.setState({ posting: true });
    ThanhTra.actions.updateKeHoachThanhTra.request({ id: this.state.detail.keHoachThanhTraId }, params).then(res => {
      if (res.data) {
        Toastr(msg.updateKHSuccess, 'success');
        setTimeout(() => {
          browserHistory.goBack();
        }, 1000);
      }
      this.setState({ posting: false });
    }).catch(error => {
      if (error.response) {
        Toastr(error.response.data.errors[0].detail, 'error');
      }
      this.setState({
        posting: false
      });
    });
  }

  onSave(data, index) {
    this.state.data[index] = data
    this.setState({ ...this.state });
  }

  handleRemove(item, index) {
    if (item.id) {
      this.props.onRemove(item.id);
    }
    this.state.data.splice(index, 1);
    this.setState({ ...this.state });
    this.props.onChange(this.state.data);
  }
  handleClose() {
    this.props.dispatch({ type: 'DSTT_GO_BACK' })
    browserHistory.goBack();
  }

  checkIsKiemTra() {
    const result = get(this.state, 'detail.loaiKeHoach.value') === 'KIEM_TRA'
    return result;
  }
  render() {
    let userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
    let info = this.state.detail || {};
    let oldInfo = info.keHoacThanhTraCuInfo;
    let displayButtonEdit = this.state.enableEdit && (userInfo.donViId === info.donViInfo.coQuanQuanLyId) && !info.daCoKeHoachBoSung && !info.activeTaoCuocThanhTra;
    return (
      <MasterLayout routerName={this.props.route.name}>
        <div className="center reception-container">
          <div className="back-foward">
            <Link onClick={this.handleClose.bind(this)} title="">Về trang trước</Link>
          </div>
          <div className="heading">
            <h2 className="heading-title icon-add">
              Kế hoạch {this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'} năm {info.namThanhTra} {oldInfo ? '(Sửa đổi, bổ sung lần 1)' : ''}
            </h2>
          </div>
          <div className="bottom-content">
            <section className='wrap-block'>
              <div className='row pl10 pr10'>
                <TextMessage className='col-100 pl20 pr20 pt10' labelClass="txt-inline-block mr5" contentClass="txt-inline-block" label='Hình thức:'
                  value={oldInfo ? `Kế hoạch ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'} sửa đổi, bổ sung` : `Kế hoạch ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'} mới`} />
              </div>
              <div className='row pl15 pr15'>
                <span className='big-border mt5'></span>
              </div>
              <div className='row pl10 pr10'>
                {
                  oldInfo ?
                    <h2 className='title-14 col-100 pt20 pl20 pr20 pb15'>1. Thông tin kế hoạch sửa đổi, bổ sung</h2>
                    :
                    <h2 className='title-14 col-100 pt20 pl20 pr20 pb15'>1. Thông tin kế hoạch thêm mới</h2>
                }
              </div>
              <div className='row pl25 pr25'>
                <Text className='input-group mb10' label={oldInfo ? 'Số quyết định SĐ, BS' : `Quyết định phê duyệt ${this.checkIsKiemTra() ? 'KHKT' : 'KHTT'}:`} value={info.quyetDinhPheDuyetKTTT} />
                <Text className='input-group mb10' label='Ngày phê duyệt:' value={info.ngayRaQuyetDinh ? moment(info.ngayRaQuyetDinh).format('DD/MM/YYYY') : ''} />
                <ShowIf condition={!oldInfo}>
                  <Text className='input-group mb10' label={`Năm ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'}:`} value={`Kế hoạch ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'} năm ` + info.namThanhTra} />
                  {
                    info.chucNangKeHoachThanhTraInfo &&
                    <Text className='input-group mb10' label={`Chức năng ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'}:`} value={info.chucNangKeHoachThanhTraInfo ? info.chucNangKeHoachThanhTraInfo.text : ''} />
                  }
                </ShowIf>
                <div className="show-lich-su-right">
                  <HistoryDialog title="Lịch sử điều chỉnh" type="ke-hoach" donId={this.props.params.id} />
                </div>
                <ShowIf condition={!oldInfo}>
                  <TextMessage className='col-100 mb10' label='Tóm tắt kế hoạch:' value={info.ghiChu} />
                </ShowIf>
              </div>
              <div className='row pl30 pr30'>
                <span className='line-border mt5 mb20'></span>
              </div>
              <ShowIf condition={oldInfo}>
                <div className='row pl10 pr10'>
                  <h2 className='title-13 col-100 pl20 pr20 pb15'>1.1 Thông tin kế hoạch {this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'} cũ</h2>
                </div>
                <div className='row pl25 pr25'>
                  <Text className='input-group mb10' label='Quyết định phê duyệt KHTT:' value={oldInfo ? oldInfo.quyetDinhPheDuyetKTTT : ''} />
                  <Text className='input-group mb10' label='Ngày phê duyệt:' value={oldInfo && oldInfo.ngayRaQuyetDinh ? moment(oldInfo.ngayRaQuyetDinh).format('DD/MM/YYYY') : ''} />
                  <Text className='input-group mb10' label={`Năm ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'}:`} value={oldInfo && oldInfo.namThanhTra ? `Kế hoạch ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'} năm ` + oldInfo.namThanhTra : ''} />
                  <Text className='input-group mb10' label='Người ký:' value={oldInfo ? oldInfo.nguoiKy : ''} />
                  <TextMessage className='col-100 mb10' label='Tóm tắt kế hoạch:' value={oldInfo ? oldInfo.ghiChu : ''} />
                </div>
                <div className='row pl30 pr30'>
                  <span className='line-border mt5 mb20'></span>
                </div>
              </ShowIf>
            </section>
            <section className='wrap-block'>
              <div className='row pl10 pr10 heading-addnew-dttt'>
                {
                  oldInfo ?
                    <h2 className='title-13 col-100 pl20 pr20'>1.2 Danh mục cuộc {this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'}</h2>
                    :
                    <h2 className='title-13 col-100 pl20 pr20'>1.1 Danh mục cuộc {this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'}</h2>
                }
              </div>
              <div className='row pl10 pr10 '>
                <DataTable header={header.thanhTra.DKKHTT3} dataList={[...info.cuocThanhTraCus, ...info.cuocThanhTras]} hideButtonExport={true} hidePagination={true} pageData={this.state.pageData} parent={this} search={this.state.search}
                  tableLoading={this.state.tableLoading}>
                  <RowItemDanhSachCuocThanhTra checkCT onSave={this.onSave.bind(this)} isSubmit={this.props.isSubmit} />
                </DataTable>
              </div>
            </section>
            <div className='row pl15 pr15'>
              <span className='big-border mt5 mb20'></span>
            </div>
            <div className='row pl30 pr30 '>
              <ContainerFileDinhKem label="2. Danh sách văn bản xử lý" labelClass="title-14" hideDescription={true} disableTopLine={true} disableAttachFile={true} dataShow={info.listTaiLieuVanThu} />
            </div>
          </div>
          <div className="action-form-wrap pt35 pb5">
            <div className="box-bottom">
              <Link className="btn-action btn-close" onClick={this.handleClose.bind(this)}><span>Đóng</span></Link>
              <ShowIf condition={!this.props.route.readonly}>
                <ShowIf condition={displayButtonEdit}>
                  <Link className="btn-action btn-edit" to={`/thanh-tra/chinh-sua-ke-hoach/${info.keHoachThanhTraId}`}>
                    <span>Sửa</span>
                  </Link>
                </ShowIf>
              </ShowIf>
            </div>
          </div>
        </div>
      </MasterLayout>
    );
  }
}

export default connect()(ChiTietDoiTuongTrung);



// WEBPACK FOOTER //
// ./src/components/modules/thanh-tra/ChiTietDoiTuongTrung.jsx